<template>
  <div class="var-group-selector">
    <div class="content-row">
      <div class="row-left">
        <tree-select
          multiple
          :group-list="groupSelectOptions"
          :value="groupSelectValue"
          @input="selectVar"
          :disabled="disabled"
        ></tree-select>
      </div>
      <div
        class="btn-add buttonSelectTrigger"
        :class="disabled ? 'btn-disabled' : ''"
        @click="openDialog"
      >
        <i class="el-icon-plus"></i>
      </div>
    </div>
    <base-dialog width="485px" class="prompt-dialog" :visible.sync="visible" show-close>
      <template v-slot:header>
        选择
      </template>
      <el-form label-position="left" label-width="60px">
        <el-form-item label="请选择">
          <address-selector
            v-if="control._type === 'area'"
            v-model="commonValue"
            :level="control.level"
            multiple
            :check-strictly="['包含(模糊)', '在...中'].includes(compareMethod)"
            size="mini"
          ></address-selector>
          <normal-select
            v-else-if="['radio', 'select', 'option'].includes(control._type)"
            :select-list="optionControlSelectList"
            :selected-item.sync="commonValue"
            multiple
          ></normal-select>
          <select-ref
            v-else-if="control._type === 'ref'"
            :control="control"
            v-model="commonValue"
          ></select-ref>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button @click="visible = false">
          取消
        </base-button>
        <base-button type="primary" @click="selectCommon(commonValue)">
          确认
        </base-button>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import AddressSelector from "@/components/AddressSelector"
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/BaseComponents/Dialog"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import mixin from "./ConditionList/mixin"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { getSheetViewData } from "@/api/sheet/sheetView"

export default {
  name: "var-group-selector",
  components: { BaseButton, BaseDialog, AddressSelector, NormalSelect, TreeSelect },
  beforeCreate() {
    this.$options.components.SelectRef = require("@/components/Sheet/SheetForm/FormItem/SelectRef").default
  },
  mixins: [mixin],
  props: {
    varGroup: Array,
    value: Array,
    control: Object,
    compareMethod: String,
    disabled: Boolean
  },
  data() {
    return {
      visible: false,
      commonValue: null,
      sheetDataMap: {}
    }
  },
  watch: {
    value: {
      handler() {
        if (this.control._type === "ref") {
          let dataIds = (this.value || [])
            .filter(varItem => !varItem.var && !this.sheetDataMap[varItem.value])
            .map(v => v.value)
          if (this._.isEmpty(dataIds)) return
          getSheetViewData({
            sheetId: this.control.refSheetId,
            dataIds,
            size: dataIds.length
          }).then(dataList => {
            this.sheetDataMap = Object.assign(
              {},
              this.sheetDataMap,
              this._.keyBy(dataList.content, "id")
            )
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    valList() {
      return (this.value || []).map(varItem =>
        Object.assign({}, varItem, {
          label: varItem.var ? this.varGroupMap[varItem] : this.getCommonLabel(varItem.value)
        })
      )
    },
    commonSelected() {
      return (this.valList || []).filter(item => !item.var)
    },
    varGroupMap() {
      return this._.keyBy(
        (this.varGroup || []).flatMap(group => group.options),
        "value"
      )
    },
    groupSelectOptions() {
      return this.commonSelected.length == 0
        ? this.varGroup
        : this.varGroup.concat({ label: "其他", options: this.commonSelected })
    },
    groupSelectValue() {
      return (this.value || []).map(t => t.value)
    }
  },
  methods: {
    getCommonLabel(val) {
      switch (this.control._type) {
        case "ref":
          return this.sheetDataMap[val]?.title || "加载中..."
        default:
          return val
      }
    },
    openDialog() {
      if (!this.disabled) {
        let val = (this._.cloneDeep(this.value) || [])
          .filter(varItem => !varItem.var)
          .map(varItem => varItem.value)
        this.commonValue = val
        switch (this.control._type) {
          case "area":
            this.commonValue = val.map(v => v.split("-"))
            break
          case "ref":
            this.commonValue = null
        }
        this.visible = true
      }
    },
    selectVar(items) {
      const oldValues = this.valList.filter(varItem => items.includes(varItem.value))
      const newValues = items
        .filter(item => !this.valList.some(varItem => varItem.value === item))
        .map(item => ({
          label: item,
          value: item,
          var: true
        }))
      this.emitVal(oldValues.concat(newValues))
    },
    selectCommon(items) {
      switch (this.control._type) {
        case "area":
          items = (items || []).map(item => item.join("-"))
          break
        case "ref":
          if (!this._.isEmpty(items)) {
            return this.emitVal(
              this.valList.concat(
                items.map(item => ({ label: item.title, value: item.id, var: false }))
              )
            )
          }
      }
      const oldValues = this.valList.filter(varItem => varItem.var || items.includes(varItem.value))
      const newValues = items
        .filter(item => !this.valList.some(varItem => !varItem.var && varItem.value === item))
        .map(item => ({
          label: item,
          value: item,
          var: false
        }))
      this.emitVal(oldValues.concat(newValues))
    },
    emitVal(val = []) {
      this.$emit("input", val)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.var-group-selector {
  .content-row {
    display: flex;
    position: relative;
    .row-left {
      flex: 1 1;
      width: 0;
    }
    .tree-select {
      ::v-deep .tree-select-tags {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-disabled {
      background: #f6f7fa;
      cursor: not-allowed;
    }
    .btn-add {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-width: 1px 1px 1px 0;
      border-style: solid;
      box-sizing: border-box;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-color: #ddd;
      font-size: 20px;
      color: #9e9e9e;
      cursor: pointer;
      &:hover {
        color: #1e88e5;
      }
    }
  }
}
.prompt-dialog {
  .el-form {
    margin-top: 18px;
    .address-selector {
      width: 100%;
    }
  }
}
</style>
